import { PrimaryTableCol } from 'tdesign-vue/es/_common/js/table/types';

type Resize = {
  colKey: string;
  resizable?: boolean;
  minWidth?: number;
  maxWidth?: number;
};

/**
 *
 * @param columns 原始的columns参数，需要包含colKey字段，以此为基础进行调整
 * @param resizableData 调整resize的参数，包含colKey、resizable、minWidth、maxWidth
 * @returns
 */

export function setResizableColumns(columns: PrimaryTableCol[], resizableData: Resize[] = []): PrimaryTableCol[] {
  const maps = new Map();
  const data = [
    {
      colKey: 'row-select',
      resizable: false,
    },
    ...resizableData,
  ];
  data.forEach(item => {
    maps.set(item.colKey, item);
  });
  const defaultResize = [
    {
      key: 'time', // 时间字段最小宽度为120，最大宽度为300
      isFuzzyMatch: true, // 是否模糊匹配
      minWidth: 120,
      maxWidth: 300,
    },
    {
      key: 'size', // 大小字段最小宽度为120，最大宽度为200
      isFuzzyMatch: true,
      minWidth: 120,
      maxWidth: 200,
    },
    {
      key: 'path', // 文件路径字段最小宽度为120，最大宽度为300
      isFuzzyMatch: true,
      minWidth: 120,
      maxWidth: 300,
    },
    {
      key: 'dynamic', // 动态字段最小宽度为200，最大无上限
      isFuzzyMatch: true,
      minWidth: 200,
      maxWidth: 100000,
    },
    {
      key: ['removed', 'createdByNickname'], // 头像字段最小宽度为120，最大宽度为200。非模糊匹配支持数组格式。
      isFuzzyMatch: false,
      minWidth: 120,
      maxWidth: 200,
    },
  ];
  return columns.map(item => {
    const resize = maps.get(item.colKey);
    if (resize) {
      return {
        ...item,
        resizable: resize.resizable ?? true, // 默认可调整
        resize: {
          minWidth: resize.minWidth ?? 80, // t-table默认最小宽度为80
          maxWidth: resize.maxWidth ?? 600, // t-table默认最大宽度为600
        },
      };
    }
    const defaultResizeItem = defaultResize.find(resizeItem => {
      if (resizeItem.isFuzzyMatch) {
        return item.colKey.toLowerCase().indexOf(resizeItem.key) > -1;
      }
      return Array.isArray(resizeItem.key) ? resizeItem.key.includes(item.colKey) : item.colKey === resizeItem.key;
    });
    if (defaultResizeItem) {
      return {
        ...item,
        resizable: true,
        resize: {
          minWidth: defaultResizeItem.minWidth,
          maxWidth: defaultResizeItem.maxWidth,
        },
      };
    }
    return item;
  });
}
